module.exports = __webpack_public_path__ + "img/catalog-item-gap-mobile.webp";